import { createPortal } from 'react-dom';
import { useRef, useEffect, useState } from 'react';
import styles from './Portal.module.scss';

type PortalProps = {
  style?: Record<string, unknown>;
  portalId?: string;
  children: React.ReactNode;
  noBodyLock?: boolean;
};

const Portal: React.FC<PortalProps> = ({
  portalId = 'portal',
  children,
  style,
  noBodyLock
}) => {
  const ref = useRef<HTMLElement>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    let portalRoot = document.getElementById(portalId);

    if (!portalRoot) {
      portalRoot = document.createElement('div');
      portalRoot.setAttribute('id', portalId);
      document.body.appendChild(portalRoot);
    }

    ref.current = portalRoot;

    setMounted(true);
  }, []);

  // Prevents background scroll when portal is open
  useEffect(() => {
    if (!noBodyLock) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    }

    return () => {
      if (!noBodyLock) {
        const scrollY = document.body.style.top;

        document.body.style.position = '';
        document.body.style.top = '';

        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    };
  }, []);

  return mounted
    ? createPortal(
        <div className={styles.container} style={style}>
          {children}
        </div>,
        ref.current
      )
    : null;
};

export default Portal;
